import { useEffect } from 'react';

const GoogleAnalytics = () => {
  useEffect(() => {
    if (import.meta.env.PROD) {
      const script = document.createElement('script');
      script.src = 'https://www.googletagmanager.com/gtag/js?id=GTM-PB5BQQ8B';
      script.async = true;
      document.head.appendChild(script);

      const gtagScript = document.createElement('script');
      gtagScript.innerHTML = `
        window.dataLayer = window.dataLayer || [];
        function gtag(){dataLayer.push(arguments);}
        gtag('js', new Date());
        gtag('config', 'GTM-PB5BQQ8B');
      `;
      document.head.appendChild(gtagScript);
    }
  }, []);
  return null;
};

export default GoogleAnalytics;
